import React, { useEffect, Suspense, lazy } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import zhTW from 'antd/locale/zh_TW';
import enUS from 'antd/locale/en_US';
import MainLayout from './components/layout/MainLayout';
import PrivateRoute from './components/auth/PrivateRoute';
import { ROUTES } from './constants/routes';
import './styles/global.scss';
import { getCurrentUser } from './services/auth';
import { useUserStore, useFilesStore } from './stores';
import { folderList, sourceTypeList } from './services/file';
import useFolderStore from './stores/folderStore';
import { getCurrentLanguage, t } from './locales';

const antdLocales = {
  zh: zhCN,
  'zh-Hant': zhTW,
  'zh-TW': zhTW,
  en: enUS,
} as const;
// 动态引入页面组件
const Login = lazy(() => import('./pages/auth/Login'));
const Register = lazy(() => import('./pages/auth/Register'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));
const Profile = lazy(() => import('./pages/profile/Profile'));
const File = lazy(() => import('./pages/file/File'));
const Feedback = lazy(() => import('./pages/feedback/Feedback'));
// import ThemeTest from './pages/ThemeTest';
// import MessageTest from './pages/MessageTest';

function App() {
  const { setCurrentUser } = useUserStore.getState();
  const { setFileTypes } = useFilesStore.getState();
  const { setFolders } = useFolderStore.getState();
  const currentLanguage = getCurrentLanguage();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      handleInitBaseInfo()
    }
    document.title = currentLanguage === 'en' ? "MindRec Web" : "悦会"
  }, [])

  const handleInitBaseInfo = async () => {
    if (localStorage.getItem('token')) {
      const response = await getCurrentUser();
      setCurrentUser(response)
      const res2 = await sourceTypeList()
      setFileTypes(res2)
      const res3 = await folderList()
      setFolders(res3.folders)
      // setFolders([
      //   {folderId: 1, createTime: '', folderName: 'name', recordingCount: 1}
      // ])
    }
  }

  return (
    <ConfigProvider 
      locale={antdLocales[currentLanguage]}
      theme={{
        token: {
          colorPrimary: '#49AAA0',
          colorPrimaryHover: '#62D6AD',
          colorPrimaryActive: '#327a73',
          colorLink: '#49AAA0',
          colorLinkHover: '#62D6AD',
          colorLinkActive: '#327a73',
          colorInfo: '#49AAA0',
          colorInfoHover: '#62D6AD',
          colorInfoActive: '#327a73',
        },
        components: {
          Message: {
            colorBgElevated: '#000',
            colorText: '#fff',
            colorBorder: '#333',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          },
        },
      }}
    >
      <Router>
        <Suspense fallback={<div style={{textAlign: 'center', marginTop: 100}}>{t('common.loading')}</div>}>
          <Routes>
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Register />} />
            <Route path={ROUTES.RESETPASSWORD} element={<ResetPassword />} />
            <Route
              path={ROUTES.PROFILE}
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Profile />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Feedback />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/file"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <File />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            {/* <Route
            path="/theme-test"
            element={
              <PrivateRoute>
                <MainLayout>
                  <ThemeTest />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}
            {/* <Route
            path="/message-test"
            element={
              <PrivateRoute>
                <MainLayout>
                  <MessageTest />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Navigate to={ROUTES.FILE} replace />
                  </MainLayout>
                </PrivateRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </ConfigProvider>
  );
}

export default App;
